<script>
    //import times from "lodash/times";
    import Button from "./form/Button.svelte";
    import {Label} from '@smui/button';
    import { createEventDispatcher } from 'svelte';
    import { crossfade, fade, fly } from 'svelte/transition';

    const [send, receive] = crossfade({
		duration: 200,
		fallback: fade,
	});

    export let buttons = true;
    export let cancelButton = false;
    export let deleteButton = false;
	export let currentIndex = 0;
	export let lastIndex;
	export let nextDisabled = false;
    export let overflow = false;
    export let style;
    export let editable = true;
    export let submitButtonText = editable ? "Submit" : "Close";

	const previous = () => currentIndex -= 1;
	const cancel = () => dispatch("cancel");
	const deleteIt = () => window.confirm("Are you sure you want to delete this?") ? dispatch("delete") : null;
	const dispatch = createEventDispatcher();

	function next() {
	    if (currentIndex == lastIndex) {
	        dispatch("end");
	    }
	    else {
	        currentIndex += 1;
	    }
	}
</script>

<div class="dialog-screen-container" class:overflow {style}>
    <div class="inner">
        <!-- default slot -->
        <slot></slot>

        <!-- for dialogscreens -->
        {#if currentIndex == 0}<slot name="screen-1" />{/if}
        {#if currentIndex == 1}<slot name="screen-2" />{/if}
        {#if currentIndex == 2}<slot name="screen-3" />{/if}
        {#if currentIndex == 3}<slot name="screen-4" />{/if}
        {#if currentIndex == 4}<slot name="screen-5" />{/if}
        {#if currentIndex == 5}<slot name="screen-6" />{/if}
        {#if currentIndex == 6}<slot name="screen-7" />{/if}
        {#if currentIndex == 7}<slot name="screen-8" />{/if}
        {#if currentIndex == 8}<slot name="screen-9" />{/if}
    </div>
</div>

{#if buttons}
    <slot name="buttons">
        <div class="action-buttons">
            {#if currentIndex > 0}
                <Button class="button-previous" on:click={previous} variant="outlined">
                    <Label>Previous</Label>
                </Button>
            {/if}

            {#if cancelButton}
                <Button class="button-cancel" on:click={cancel} variant="outlined">
                    <Label>Cancel</Label>
                </Button>
            {/if}

            {#if deleteButton}
                <Button class="button-delete" on:click={deleteIt} variant="outlined" style="border-color: #c00; border-color: var(--mdc-theme-primary,#c00); color: #c00;">
                    <Label>Delete...</Label>
                </Button>
            {/if}

            <Button class="button-next" disabled={nextDisabled} on:click={next} style="float: right;">
                <Label>
                    {#if currentIndex < lastIndex}
                        Next
                    {:else}
                        {submitButtonText}
                    {/if}
                </Label>
            </Button>
        </div>
    </slot>
{/if}

<style>
    /* this large width allows the smooth transition of DialogScreens */
    .inner {
        width: 1000px;
    }
    .dialog-screen-container {
        max-width: 100%;
        overflow: hidden;
    }

    .dialog-screen-container.overflow {
        overflow: visible;
    }

    :global(.button-delete) {
        border-color: #c00;
        border-color: var(--mdc-theme-primary,#c00);
        color: #c00;
    }
</style>